<template>
  <div>
    <div v-if="!loading">
        <div class="applicant-jobs-container">
          <div>
            <FilterJob
              v-on:filterHandler="filterHandler"
              :firstTitle="'Status'"
              :secondTitle="'Specialization'"
              :firstOptions="firstOptions"
              :secondOptions="secondOptions"
              :firstSelectedValue="firstSelectedValue"
              :secondSelectedValue="secondSelectedValue"
            />
          </div>

          <div v-if="bodyList !== null">
            <ListTable
              :headList="headList"
              :bodyList="currentJobsList"
              :emptyStateTitle="'Applications'"
              :emptyListDescription="'No Applications Yet, Start by Creating a Job'"
              v-if="!loading"
              v-on:viewHandler="viewApplicationDetails"
            />
          </div>

          <!-- Create Job Button -->
          <div v-if="bodyList.length === 0" class="redirect-to-jobs">
            <button @click="redirectToJobs()">
              <!-- <span class="plus-icon">+</span> Create a Job -->
               Create a Job
            </button>
          </div>

        </div>

        <div class="pagination">
          <Pagination
            v-if="bodyList !== null && bodyList.length > 0"
            v-bind:itemsPerPage="itemsPerPage"
            v-bind:totalJobs="bodyList.length"
            v-bind:currentPage="currentPage"
            v-on:paginate="paginate"
          />
        </div>
    </div>

    <div v-if="loading">
      <FilterJob
        v-on:filterHandler="filterHandler"
        :firstTitle="'Status'"
        :secondTitle="'Specialization'"
        :firstOptions="firstOptions"
        :secondOptions="secondOptions"
        :firstSelectedValue="firstSelectedValue"
        :secondSelectedValue="secondSelectedValue"
        class="applicant-jobs-container"
      />

      <!-- Loader -->
      <div class="loading-text">
        <p>Please wait</p>
        <div v-bind:class="{ loading: loading }"></div>
      </div>

    </div>
  </div>
</template>

<script>
import ListTable from '../../components/body/ListTable.vue';
import FilterJob from '../../components/body/FilterJob.vue';
import threeDotsIcon from '../../assets/images/tableDots.png';
import Pagination from '../../components/Pagination.vue';

export default {
  name: 'AdminApplicationsList',
  components: {
    ListTable,
    FilterJob,
    Pagination
  },
  data() {
    return {
      allApplications: null,
      loading: true,

      headList: [
        {
          text: 'JOB TITLE',
        },
        {
          text: 'COMPANY',
        },
        {
          text: 'APPLICANT',
        },
        {
          text: 'LOCATION',
        },
        {
          text: 'STATUS',
        },
        {
          text: 'DATE APPLIED',
        },
        {
          text: '',
        },
      ],
      bodyList: null,
      threeDotsIcon,

      firstOptions: [
        { id: 1, name: 'All Status', value: 'allStatus', selected: true },
        { id: 2, name: 'In Review', value: 'in-review' },
        { id: 3, name: 'Shortlisted', value: 'shortlisted' },
        { id: 4, name: 'Scheduled for Interview', value: 'scheduled-for-interview'},
        { id: 5, name: 'Hired', value: 'hired' },
        { id: 6, name: 'Declined', value: 'declined' },
      ],
      secondOptions: [
        { name: 'All Specialization', value: 'allSpecialization', selected: true },
        { name: 'Technology', value: 'Technology' },
        { name: 'Education', value: 'Education' },
        { name: 'Product Design', value: 'Product Design' },
        { name: 'Product Management', value: 'Product Management' },
        { name: 'Project Management', value: 'Project Management' },
        { name: 'Administration', value: 'Administration' },
        { name: 'Operations', value: 'Operations' },
        { name: 'Sales', value: 'Sales' },
        { name: 'Marketing', value: 'Marketing' },
        { name: 'Customer Service', value: 'Customer Service' },
        { name: 'Human Resources', value: 'Human Resources' },
        { name: 'Creative & Design', value: 'Creative and Design' },
        { name: 'Media & Communications', value: 'Media and Communications' },
        { name: 'Health & Wellness', value: 'Health and Wellness' },
        { name: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { name: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { name: 'Science & Research', value: 'Science and Research' },
        { name: 'Agriculture', value: 'Agriculture' },
        { name: 'Finance', value: 'Finance' },
        { name: 'Supply Chain', value: 'Supply Chain' },
        { name: 'Engineering', value: 'Engineering' },
        { name: 'Building & Construction', value: 'Building and Construction' },
        {
          name: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { name: 'Legal', value: 'Legal' },
        { name: 'Energy & Utilities', value: 'Energy and Utilities' },
        { name: 'Telecommunications', value: 'Telecommunications' },
        {
          name: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          name: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        { name: 'Manufacturing', value: 'Manufacturing' },
        { name: 'Healthcare', value: 'Healthcare' },
        { name: 'Others', value: 'Others' },
      ],
      firstSelectedValue: 'allStatus',
      secondSelectedValue: 'allSpecialization',

      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  async mounted() {
    this.getAllApplications();
  },
  methods: {
    async getAllApplications() {

      this.bodyList = [];
      this.allApplications = [];
      let body = {};

      await this.$store.dispatch('getAllApplications')
      .then(() => {
        let results = this.$store.state.allApplications;

        results.forEach((application) => {
          body = {
            dateApplied: new Date(application.createdAt).toDateString(),
            status: application.status,
            id: application.id,
            fullName: application.applicantInfo && application.applicantInfo.firstName &&
              application.applicantInfo.lastName ?
              `${application.applicantInfo.firstName} ${application.applicantInfo.lastName}` :
              '—',
            jobTitle: application.jobInfo && application.jobInfo.title ? application.jobInfo.title : '—',
            company: application.jobInfo && application.jobInfo.companyName ?
             application.jobInfo.companyName :
             '—',
            category: application.jobInfo? application.jobInfo.category: '',
            location: application.jobInfo && application.jobInfo.city && application.jobInfo.state ?
              `${application.jobInfo.city}, ${application.jobInfo.state}` :
              '—',
            threeDotsIcon: threeDotsIcon,
          };

          this.bodyList.push(body);

        });

        // Always return the newest/most recent applications data
        this.bodyList = this.bodyList.reverse();
        this.allApplications = this.bodyList;
        this.loading = false;

        // eslint-disable-next-line no-sequences
        return this.bodyList, this.allApplications;

      })
      .catch((err) => {
        this.loading = false;
        this.$toastr.error(err, 'Error');
      });

    },
    viewApplicationDetails(applicationId) {
      this.$emit('viewApplication', applicationId);
    },
    filterHandler(selectedOptions) {
      this.currentPage = 1;

      const { firstOption, secondOption } = selectedOptions;

      // Start with all applications
      let result = [...this.allApplications];

      // --- STATUS FILTER ---
      if (firstOption !== null && firstOption !== 'allStatus') {
        result = result.filter(app => app.status === firstOption);
      }

      // --- SPECIALIZATION FILTER ---
      if (secondOption !== null && secondOption !== 'allSpecialization') {
        result = result.filter(app => app.category === secondOption);
      }

      this.bodyList = result;
    },
    multiFilterHandler(selectedOptions) {
      this.currentPage = 1;

      // Map filter keys to fields and their "all" values
      const filterConfig = {
        firstOption: { field: 'status', allValue: 'allStatus' },
        secondOption: { field: 'category', allValue: 'allSpecialization' }
      };

      // Start with all applications
      let result = [...this.allApplications];

      // Apply filters dynamically
      for (const [optionKey, config] of Object.entries(filterConfig)) {
        const selectedValue = selectedOptions[optionKey];

        if (!selectedValue) continue; // skip null/undefined/empty

        // Support multi-select (array) or single value
        const valuesToFilter = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

        // Skip if it contains the "all" value
        if (valuesToFilter.includes(config.allValue)) continue;

        // Apply the filter
        result = result.filter(app => valuesToFilter.includes(app[config.field]));
      }

      // Update the displayed list
      this.bodyList = result;

      return result;
    },
    redirectToJobs() {
      this.$emit('redirectToJobs', 'Jobs');
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    }
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },
    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },
    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    }
  },
};
</script>
<style scoped>
  @keyframes buttonLoadingSpinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }
  .loading-text {
    position: relative;
    display: flex;
    align-items: center;
    /* height: 70vh; */
    margin-top: 50px;
    color: white;
    justify-content: center;
  }
  .loading::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: var(--white);
    border-right-color: var(--white);
    border-radius: 50%;
    animation: buttonLoadingSpinner 1s linear infinite;
  }
  .applicant-jobs-container {
    background: var(--white);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
    border-radius: 10px 10px;
  }
  .redirect-to-jobs {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .redirect-to-jobs button {
    width: 205px;
    height: 54px;
    background: var(--colorPrimary);
    color: var(--white);
    border-radius: 5px;
    margin: 25px;
    font-size: 1.1rem;
  }
  .plus-icon {
    margin-right: 10px;
  }
  .pagination {
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    justify-content: right;
    align-items: center;
  }
</style>
